var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgBell = function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 100 100",
    preserveAspectRatio: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M44.9,87.5c6.9,0,12.5-5.6,12.5-12.5h-25C32.4,81.9,38,87.5,44.9,87.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7,51.6V35.9c0-12.1-8.3-22.2-19.5-25V6.2c0-3.4-2.8-6.3-6.3-6.3s-6.2,2.8-6.2,6.3V11c-11.2,2.8-19.5,12.9-19.5,25v15.6c0,4.4-2.2,6.5-4.5,8.8c-2.4,2.4-4.9,4.9-4.9,9.9c0,0.4,0.3,0.8,0.8,0.8h68.7c0.4,0,0.8-0.3,0.8-0.8c0-5-2.5-7.5-4.9-9.9C72.8,58.1,70.7,55.9,70.7,51.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9,20.9c0.6,0,1.1-0.2,1.5-0.6l6.3-6.3c0.8-0.9,0.8-2.2,0-3.1c-0.8-0.9-2.2-0.9-3.1,0l-6.3,6.3c-0.8,0.9-0.8,2.2,0,3.1C68.8,20.7,69.3,20.9,69.9,20.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6,27.2c0.4,0.7,1.1,1.1,1.9,1.1c0.4,0,0.7-0.1,1.1-0.3l7.7-4.4c1.1-0.6,1.4-1.9,0.8-3c-0.6-1-1.9-1.4-3-0.8l-7.7,4.4C73.4,24.8,73,26.1,73.6,27.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7,31.7c-0.3-1.2-1.5-1.9-2.7-1.5l-8.5,2.3c-1.2,0.3-1.9,1.5-1.5,2.7c0.3,1,1.1,1.6,2.1,1.6c0.2,0,0.4,0,0.6-0.1l8.5-2.3C89.3,34.1,90,32.9,89.7,31.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3,20.3c0.4,0.4,1,0.6,1.5,0.6s1.1-0.2,1.5-0.6c0.9-0.9,0.9-2.2,0-3.1L15.2,11c-0.9-0.9-2.2-0.9-3.1,0c-0.9,0.9-0.9,2.2,0,3.1L18.3,20.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5,23.5l7.7,4.4c0.3,0.2,0.7,0.3,1.1,0.3c0.8,0,1.5-0.4,1.9-1.1c0.6-1,0.2-2.4-0.8-3l-7.7-4.4c-1-0.6-2.4-0.2-3,0.8C4.1,21.6,4.5,22.9,5.5,23.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7,36.8c1,0,1.9-0.6,2.1-1.6c0.3-1.2-0.4-2.4-1.5-2.7l-8.5-2.3c-1.2-0.3-2.4,0.4-2.7,1.5c-0.3,1.2,0.4,2.4,1.5,2.7l8.5,2.3C10.3,36.8,10.5,36.8,10.7,36.8"
  }))));
};

export default __webpack_public_path__ + "static/media/Bell.f81e9923.svg";
export { SvgBell as ReactComponent };